export enum DeviceTypesEnum {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
